import { DateTime } from 'luxon'

export function formatDate(isoString) {
  const date = new Date(isoString)
  const options = { year: '2-digit', month: '2-digit', day: '2-digit' }
  return new Intl.DateTimeFormat('en-US', options).format(date)
}

export function formatTime(isoString) {
  const date = new Date(isoString)
  const options = { hour: 'numeric', minute: 'numeric', hour12: true, second: 'numeric' }
  return new Intl.DateTimeFormat('en-US', options).format(date)
}

export function formatDateTime(isoString) {
  return formatDate(isoString) + ' ' + formatTime(isoString)
}

export function isToday(jsDate) {
  if (!jsDate) {
    throw new Error('Date is required')
  }
  const date = DateTime.fromJSDate(jsDate)
  const today = DateTime.now()
  return date.hasSame(today, 'day')
}

export function isTomorrow(jsDate) {
  if (!jsDate) {
    throw new Error('Date is required')
  }
  const date = DateTime.fromJSDate(jsDate)
  const tomorrow = DateTime.now().plus({ days: 1 })
  return date.hasSame(tomorrow, 'day')
}
